<div class="modal-header">
    <h5 class="modal-title">{{ 'formPageSettings.title' | t }}</h5>
</div>
<div class="container-fluid">
    @if (pages) {
        <mat-accordion
            class="sortable-list"
            [sortablejs]="pages"
            [sortablejsOptions]="sortingOptions"
        >
            @for (page of pages; track page; let pageIndex = $index) {
                <mat-expansion-panel [id]="page.ID">
                    <mat-expansion-panel-header>
                        <mat-panel-title>
                            {{ page.Title }}
                            @if (page.ID === lockedFirstPageID && pageIndex !== 0) {
                                <span class="alert">{{ 'formPageSettings.lockedFirstPage' | t }}</span>
                            }
                        </mat-panel-title>
                        <mat-panel-description>
                            {{ 'formPageSettings.pageType' | t: { type: page.Type == 1 ? "entry" : "review" } }}
                        </mat-panel-description>
                    </mat-expansion-panel-header>
                    <div class="form-group">
                        <label for="form-title">{{ 'formPageSettings.titleLabel' | t }}</label>
                        <cerrix-textfield
                            cssClass="form-control"
                            [id]="'form-title-' + page.ID"
                            [(ngModel)]="page.Title"
                            placeholder="{{ 'formPageSettings.titlePlaceholder' | t }}"
                        ></cerrix-textfield>
                    </div>
                    <div class="form-group">
                        <label for="form-description">{{ 'formPageSettings.tooltipLabel' | t }}</label>
                        <cerrix-textfield
                            cssClass="form-control"
                            [id]="'form-description-' + page.ID"
                            [(ngModel)]="page.Tooltip"
                            placeholder="{{ 'formPageSettings.tooltipPlaceholder' | t }}"
                        ></cerrix-textfield>
                    </div>
                    @if (isWorkflow) {
                        <div class="form-group">
                            <label for="form-category">{{ 'formPageSettings.pageTypeLabel' | t }}</label>
                            <select
                                class="custom-select"
                                id="form-category"
                                [(ngModel)]="page.Type"
                                [disabled]="page.ID > 0"
                            >
                                <option value="1" selected>{{ 'formPageSettings.entryPageOption' | t }}</option>
                                <option value="2">{{ 'formPageSettings.reviewPageOption' | t }}</option>
                            </select>
                        </div>
                    }
                    <mat-action-row>
                        <button class="btn btn-dark align-right" (click)="duplicate(pageIndex)">
                            {{ 'formPageSettings.duplicateBtn' | t }}
                        </button>
                    </mat-action-row>
                </mat-expansion-panel>
            }
        </mat-accordion>
    }
</div>
<div class="modal-footer">
    <button type="button" class="btn btn-primary" (click)="onSaveChanges()">{{ 'formPageSettings.applyChangesBtn' | t }}</button>
    <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">{{ 'formPageSettings.cancelBtn' | t }}</button>
</div>
